import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'

const { t } = useI18n()

const module: RouteRecordRawArgumented = {
  path: 'invoice-xml',
  name: 'invoiceXml',
  redirect: () => ({ name: 'invoiceXmlIndex' }),
  meta: {
    auth: {
      permission: 'invoice_xml_access',
    },
  },
  children: [
    {
      path: '',
      name: 'invoiceXmlIndex',
      component: () =>
        import(
          /* webpackChunkName: "invoice-xml-index" */ 'pages/invoice-xml/IndexPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.invoice_xml.index'),
          icon: 'mdi-file-xml-box',
        },
        auth: {
          permission: 'invoice_xml_access',
        },
      },
    },
  ],
}

export default module
